"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PhraseSpottingIcon = function PhraseSpottingIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "21",
    height: "20",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.8331 17.5H4.58252C4.41676 17.5 4.25779 17.4342 4.14058 17.3169C4.02337 17.1997 3.95752 17.0408 3.95752 16.875V3.125C3.95752 2.95924 4.02337 2.80027 4.14058 2.68306C4.25779 2.56585 4.41676 2.5 4.58252 2.5H12.0831L16.4581 6.875V16.875C16.4581 16.9571 16.442 17.0383 16.4106 17.1142C16.3791 17.19 16.3331 17.2589 16.2751 17.3169C16.217 17.375 16.1481 17.421 16.0723 17.4524C15.9965 17.4838 15.9152 17.5 15.8331 17.5Z",
    stroke: "#677791",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.083 2.5V6.875H16.4586",
    stroke: "#677791",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.4419 13.1094L12.6919 14.3594",
    stroke: "#677791",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.89502 13.75C11.1031 13.75 12.0825 12.7706 12.0825 11.5625C12.0825 10.3544 11.1031 9.375 9.89502 9.375C8.6869 9.375 7.70752 10.3544 7.70752 11.5625C7.70752 12.7706 8.6869 13.75 9.89502 13.75Z",
    stroke: "#677791",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var _default = PhraseSpottingIcon;
exports["default"] = _default;